import { LogIn, ShieldAlert } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useAuth } from "@/contexts/AuthContext";
import { redirectToLogin } from "@/lib/api";

export function LoginPage() {
  const { state } = useAuth();

  return (
    <div className="flex min-h-full items-center justify-center bg-muted/40 p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="mb-2 inline-flex h-10 w-10 items-center justify-center rounded-md bg-primary text-primary-foreground">
            ArkiveAI
          </div>
          <CardTitle className="text-xl">운영 포털 로그인</CardTitle>
          <CardDescription>
            pilgrims 계정으로 로그인합니다. 사무실 IP에서만 접속이 허용됩니다.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {state.status === "denied" && (
            <Alert variant="destructive">
              <ShieldAlert className="h-4 w-4" />
              <AlertTitle>접근 권한 없음</AlertTitle>
              <AlertDescription>
                {state.reason ??
                  "이 계정은 운영 포털 관리자 명단에 포함되어 있지 않습니다. 운영 담당자에게 문의하세요."}
              </AlertDescription>
            </Alert>
          )}

          <Button
            className="w-full"
            size="lg"
            onClick={() => redirectToLogin("/monitor")}
          >
            <LogIn className="mr-2 h-4 w-4" />
            pilgrims 계정으로 로그인
          </Button>

          <p className="text-xs text-muted-foreground">
            로그인이 안 될 때는 (1) 사무실 IP 인지, (2) admin_allowlist 에 등록된 계정인지 운영 담당자에게 확인하세요.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
